module.exports = __webpack_public_path__ + "static/media/wallStreet.eea8db9c.jpg";